import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { ProductConversionService } from './product-conversion.service';
import { ProductConversionRequestDto } from './dto/product-conversion.request.dto';
import { ProductConversionDetailsResponseModel, ProductConversionResponseModel } from '@gtpl/shared-models/production-management';
import { PlantIdRequest } from '@gtpl/shared-models/masters';

@ApiTags('product-conversion')
@Controller('product-conversion')
export class ProductConversionController {
    constructor(
        private productConversionService: ProductConversionService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ) { }

    @Post('/createProductConversion')
    async createProductConversion(@Body() productConversionRequestDto: ProductConversionRequestDto, isUpdate: boolean): Promise<ProductConversionResponseModel> {
        try {
            return await this.productConversionService.createProductConversion(productConversionRequestDto, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ProductConversionResponseModel, error)
        }
    }

    @Post('/getProductConversionDetails')
    async getProductConversionDetails(@Body() productConversionRequestDto: PlantIdRequest): Promise<ProductConversionDetailsResponseModel> {
        try {
            return await this.productConversionService.getProductConversionDetails(productConversionRequestDto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ProductConversionDetailsResponseModel, error)
        }
    }

}